
import { FormSectionCollapsible } from 'twyne-new.ui';

const Collapsible = ({ children, header, ...props }) => <FormSectionCollapsible
  defaultOpen
  border
  triggerClass='py-0 twy-subtle-neutral px-2'
  sectionClass='w-full'
  contentClass='p-0 pt-2!'
  titleClass='text-base pr-2'
  title={header}
  {...props}
>
  {children}
</FormSectionCollapsible>

export default Collapsible;
